import { QueryClientProvider } from "@tanstack/react-query"

import "./App.scss"

import AppRouter from "./AppRouter"
import { queryClient } from "./utils/queryClient"

function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  )
}

export default App
